import AvApi from '@availity/api-axios';
import getEssentialsUrl from '../config';

class SessionApi extends AvApi {
  constructor() {
    super({
      url: `${getEssentialsUrl()}/availity/SessionRefreshServlet`,
      api: false,
      withCredentials: true,
      sessionBust: false,
    });
  }

  refreshSession() {
    return this.create({});
  }
}

export default new SessionApi();
